import React, {Component} from 'react';
const { connect } = require('react-redux');
import {Link} from 'components/ReactRouterDomLocalized';
import Modal from 'react-bootstrap-modal';
import {Redirect} from 'react-router';
import queryString from 'query-string';

import {Form, ErrorContainer, InputWrapper} from 'form';
import ModalFaqBlock from 'components/faq/ModalFaqBlock';
import ToggleButton from 'components/ToggleButton';
import SelectButtons from 'components/SelectButtons';

import {t, dt} from 'l10n';

import 'sass/modals/modalMyBobTV.scss';

import {
    createMemberPersonalRoom,
    updateMemberPersonalRoom,
    deleteMemberPersonalRoom
} from 'backend-helpers/memberPersonalRooms';

import {getMemberPersonalRoom} from 'reducers/member';
import {getPersonalRooms} from 'reducers/main';

import {getPaymentUrl} from '../../utils/url';

import {REQUIRED_MEMBERSHIP_DURATION} from 'constants/mybobtv'

class ModalMyBobTVRoom extends Component {
    constructor(props) {
        super(props);

        this.state = this.getStateValues(props);

        this.state.showroomActivated = props.room ? (props.room.showroom_price ? props.room.showroom_price > 0 : false) : false;
        this.onSubmit = this.onSubmit.bind(this);
        this.onDeleteSubmit = this.onDeleteSubmit.bind(this);
        this.onSubmitSuccess = this.onSubmitSuccess.bind(this);
        this.onActivateShowroomClick = this.onActivateShowroomClick.bind(this);
        this.onDeactivateShowroomClick = this.onDeactivateShowroomClick.bind(this);        
    }

    getStateValues(props) {
        return {
            error: props.error,
            action: props.action,
            newRoom: !props.room,
            roomBlocked: props.currentUser && props.currentUser.mybobtv_disabled !== null,
            deleteRequested: false
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState(this.getStateValues(nextProps));
        if (!this.props.room && nextProps.room) {
            this.setState({showroomActivated: nextProps.room.showroom_price ? nextProps.room.showroom_price > 0 : false});
        }
    }

    onSubmit(formData, setErrors) {
        let backendData = formData;
        /*if (!this.state.showroomActivated) {
            formData.showroom_price = 0;
        }*/
        let backendFn = this.state.newRoom ? createMemberPersonalRoom : updateMemberPersonalRoom;

        backendFn(backendData)
            .then(this.onSubmitSuccess)
            .catch((error) => setErrors(error.message));
    }

    onSubmitSuccess() {
        this.props.closeFn();
        this.props.getPersonalRooms();
        this.props.getMemberPersonalRoom();
    }
    
    onActivateShowroomClick() {
        this.setState({showroomActivated: true});
    }

    onDeactivateShowroomClick() {
        this.setState({showroomActivated: false});
    }

    getForm(props) {
        let {closeFn, room} = props;
        let defaultShowroomPrice = props.room ? (props.room.showroom_price ? props.room.showroom_price : 1) : 1;

        return (
            <Form onSubmit={this.onSubmit} className="form">
                <ErrorContainer data-errorcontainer={true} />

                {room && <input type="hidden" name="roomid" defaultValue={room.roomid}/>}

                <div className="form-group">
                    <label>{dt('mybobtv', 'Room name')}</label>
                    <input type="text" name="name" maxLength="50" defaultValue={room ? room.name : ''}/>
                </div>

                { /*
                <div className="form-group">
                    <ToggleButton title={dt('mybobtv', "Activate MY | SHOW")} active={this.state.showroomActivated} onToggleOn={this.onActivateShowroomClick} onToggleOff={this.onDeactivateShowroomClick} titleWhenOn={dt('mybobtv', 'Slide to close')} titleWhenOff={dt('mybobtv', 'Slide to open')}/>
                </div>
                {this.state.showroomActivated &&
                    <div className="form-group">                    
                        <label>{dt('mybobtv', 'MY | SHOW price, tokens per minute')}</label>
                        <SelectButtons name="showroom_price" values={[1,2,3,4,5]} defaultValue={defaultShowroomPrice} />
                    </div>
                }
                */ }

                <div className="form-group removal">
                    {/*
                    <div className="selects">
                        <div className="radio">
                            <input type="radio" id="select2" name="active" value="1" defaultChecked={room && room.active}/>
                            <label htmlFor="select2">{dt('mybobtv', 'Opened')}</label>
                        </div>
                        <div className="radio">
                            <input type="radio" id="select1" name="active" value="0" defaultChecked={room ? !room.active : true}/>
                            <label htmlFor="select1">{dt('mybobtv', 'Closed')}</label>
                        </div>
                        {room &&
                            <div className="radio">
                                <input type="radio" id="select3" name="active" value="-1"/>
                                <label htmlFor="select3">{dt('mybobtv', 'Delete')}</label>
                            </div>
                        }
                    </div>
                    */}
                    {room && <a className="delete-room" onClick={() => this.setState({deleteRequested: true})}>{dt('mybobtv', 'Delete')}</a>}
                </div>

                <div className="form-group-buttons">
                    <button type="submit" className="save-name">{dt('mybobtv', 'Save')}</button>
                    <button type="button" className="close-name" onClick={closeFn}>{t('Cancel')}</button>
                </div>

            </Form>
        )
    }

    onDeleteSubmit(formData, setErrors) {
        let backendData = formData;

        let backendFn = deleteMemberPersonalRoom;
        backendData = formData.roomid;

        backendFn(backendData)
            .then(this.onSubmitSuccess)
            .catch((error) => setErrors(error.message));
    }

    getDeleteForm(props) {
        let {closeFn, room} = props;

        return (
            <Form onSubmit={this.onDeleteSubmit} className="form">
                <ErrorContainer data-errorcontainer={true} />

                {room && <input type="hidden" name="roomid" defaultValue={room.roomid}/>}

                <div className="confirmation">
                    {dt('mybobtv', 'Are you sure you want to delete your room?')}
                </div>

                <div className="form-group-buttons">
                    <button type="submit" className="save-name">{dt('mybobtv', 'Delete')}</button>
                    <button type="button" className="close-name" onClick={() => this.setState({deleteRequested: false})}>{t('Cancel')}</button>
                </div>

            </Form>
        )
    }

    render() {
        let {show, closeFn, currentUser, room} = this.props;

        if (show && (!currentUser || !currentUser.isLoggedIn()))
            return <Redirect to="/?login&return_path=%2F"/>;

        if (!currentUser || !currentUser.isLoggedIn()) {
            return null;
        }
        
        let daysToPayUp = REQUIRED_MEMBERSHIP_DURATION - currentUser.membership_duration;

        if (this.state.action === 'open' && !currentUser.isXXL()) {
            return (
                <Modal show={show} className="modalMyBobTV">
                    <Modal.Body>
                        <div className="close" onClick={closeFn}/>

                        <p className="modal-title">{dt('mybobtv', 'Open my room')}</p>

                        <p className="xxl-text" dangerouslySetInnerHTML={{__html:
                                t("You must be XXL member to open the room.")
                        }}/>

                        <Link to={getPaymentUrl(this.props.returnPath)} className="buy-xxl-button">{
                                t("Buy XXL")
                        }</Link>
                    </Modal.Body>
                </Modal>
            )
        }

        if (this.state.action !== 'edit' && (daysToPayUp > 0 || !currentUser.isXXL())) {
            return (
                <Modal show={show} className="modalMyBobTV">
                    <Modal.Body>
                        <div className="close" onClick={closeFn}/>

                        <p className="modal-title">{dt('mybobtv', 'Create my room')}</p>

                        <p className="xxl-text" dangerouslySetInnerHTML={{__html:
                            (!currentUser.isXXL() && daysToPayUp <= 0) ?
                                t("You must be XXL member to create the room.") :
                                (
                                    currentUser.isXXL() ?
                                        t("To create a room, you must have a <strong>minimum of %1 days of XXL</strong> (expired or in progress) on your account. You must buy at least %2 days of XXL.", REQUIRED_MEMBERSHIP_DURATION, daysToPayUp) :
                                        t("To create a room, you must have a <strong>minimum of %1 days of XXL</strong> (expired or in progress) on your account.", REQUIRED_MEMBERSHIP_DURATION, REQUIRED_MEMBERSHIP_DURATION)
                                )
                        }}/>

                        <Link to={getPaymentUrl(this.props.returnPath)} className="buy-xxl-button">{
                            daysToPayUp > 0 ?    
                                t("Buy %1 days of XXL", daysToPayUp) :
                                t("Buy XXL")
                        }</Link>
                    </Modal.Body>
                </Modal>
            )
        }

        if (this.state.action === 'error') {
            return (
                <Modal show={show} className="modalMyBobTV">
                    <Modal.Body>
                        <div className="close" onClick={closeFn}/>

                        <p className="xxl-text">{this.state.error}</p>

                        <button type="button" className="close-button" onClick={closeFn}>{t('Close')}</button>
                    </Modal.Body>
                </Modal>
            )
        }

        let {roomBlocked, deleteRequested} = this.state;

        let blockReason = currentUser.mybobtv_disabled ? currentUser.mybobtv_disabled.reason : '';

        return (
            <Modal show={show} className="modalMyBobTV">
                <Modal.Body>
                    <div className="close" onClick={closeFn}/>

                    <p className="modal-title">
                        {this.state.newRoom ?
                            dt('mybobtv', 'Create my room') :
                            dt('mybobtv', 'Edit my room')
                        }
                    </p>

                    {!roomBlocked ?
                        deleteRequested ? this.getDeleteForm(this.props) : this.getForm(this.props)
                     :
                        <div className="blocked">
                            {dt('mybobtv', 'My room is blocked permanently by Bob')}<br/><br/>
                            {dt('mybobtv', 'Reason:')} {blockReason}
                        </div>
                    }

                    <div className="form-group">
                        <ModalFaqBlock items={[
                            dt('mybobtv', 'You are responsible for the content of your room. Please respect the BobTV Terms and Conditions by monitoring text, photo and video materials.'),
                            dt('mybobtv', 'Collective moderation is functional on your room but as a creator you can disconnect a user with a single exclusion request.'),
                            dt('mybobtv', 'Users you have blocked can not enter your room.'),
                            dt('mybobtv', 'When you leave the room you are free to close it or not. It will close automatically when it is empty.')
                        ]}/>
                    </div>
                </Modal.Body>
            </Modal>
        )
    }
}

function mapStateToProps(state) {
    return {
        currentUser: state.currentUser
    }
}

let mapDispatchToProps = {
    getMemberPersonalRoom: getMemberPersonalRoom,
    getPersonalRooms: getPersonalRooms
};

export default connect(mapStateToProps, mapDispatchToProps)(ModalMyBobTVRoom);


// WEBPACK FOOTER //
// ./src/components/modals/ModalMyBobTVRoom.js